import {TranslateLoader} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {FirestoreService} from "../../services/firestore.service";

/**
 * Custom translation loader for `@ngx-translate/core` that fetches English and Dutch
 * localization dictionaries directly from Cloud Firestore.
 */
export class CustomLoader implements TranslateLoader {
  /** English translation dictionary object. */
  en: any;
  /** Dutch translation dictionary object. */
  nl: any;

  /**
   * Subscribes to Firestore language documents on initialization.
   * @param firestoreService - Firestore service instance.
   */
  constructor(private firestoreService: FirestoreService) {
    this.firestoreService.getLanguageJSON('en').subscribe(enDS => {
      this.en = enDS.data();
    });
    this.firestoreService.getLanguageJSON('nl').subscribe(nlDS => {
      this.nl = nlDS.data();
    });
  }

  /**
   * Retrieves translation dictionary for the requested language code.
   * @param lang - ISO language identifier (e.g. 'en', 'nl').
   * @returns Observable emitting the translation key-value dictionary.
   */
  getTranslation(lang: string): Observable<any> {

    const options = {
      async: false,
      breaks: false,
      extensions: null,
      gfm: true,
      hooks: null,
      pedantic: false,
      silent: false,
      tokenizer: null,
      walkTokens: null,
    };

    switch (lang) {
      case 'en':
        return of(this.en); // the rxjs 'of' is to simulate an Observable (expected) return for this class
      case 'nl':
        return of(this.nl);
      default:
        return of(this.en);
    }
  }
}

